import {
    faEdit,
    faSave,
    faTrash,
    faUser,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import ModalComponent from "../../../Components/Modais";

import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../Components/Table";
import OrSpinner from "../../../Components/Utils/OrSpinner";

import {
    DeletaEquipeVendasController,
    ExportarEquipeVendasController,
    ListarEquipesDeVendasController,
} from "../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { IListarEquipesVendas } from "../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";
import { CriarEquipeDeVendas } from "./EquipeDeVenda";
import React from "react";
import ProdutosDesvinculadosUsuarioPorEquipe from "../GestaoVincularProdutos/GestaoUsuariosPorEquipeVendas/VinculoUsuarioPorEquipeVenda/DesvinculoUsuarioPorEquipeVenda";
import ProdutosVinculadosUsuarioPorEquipe from "../GestaoVincularProdutos/GestaoUsuariosPorEquipeVendas/VinculoUsuarioPorEquipeVenda/ProdutoVinculadoUsuariosPorEquipe";
import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import ProdutosVinculados from "../GestaoVincularProdutos/ProdutosVinculados";
import ProdutosDesvinculados from "../GestaoVincularProdutos/ProdutosDesvinculados";
import {
    DesvincularUsuarioEquipeVendasController,
    ListarUsuarioEquipeVendaDesvinculadoController,
    ListarUsuarioEquipeVendasController,
    VincularUsuarioEquipeVendasController,
} from "../../../Controllers/Vendas/EquipeVendas/UsuarioEquipeVenda/UsuarioEquipeVenda";
import { IUsuarioPorEquipeVendas } from "../../../Interfaces/Vendas/EquipeVendas/UsuarioEquipeVendas/UsuarioEquipeVendas";
import {
    VincularProdutoEquipeVendaController,
    ListarProdutosDesvinculadosPorVendaController,
    DeletarProdutoEquipeVendaController,
    ListarProdutosVinculadosPorVendaController,
} from "../../../Controllers/Vendas/GestaoProdutosVinculadosController/GestaoProdutosVinculados";
import { IGestaoProdutosVinculados } from "../../../Interfaces/Vendas/GestaoProdutoVinculados/GestaoProdutosVinculadosInterface";

export default function GestaoCadastro() {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const [show, SetShow] = useState(false);
    const [Modal, SetModal] = useState<IComponentModal>();

    const { execute: ExportEquipeVendas } = useAsyncCallback(
        ExportarEquipeVendasController
    );

    const {
        execute: listarEquipeVendas,
        value: listarTiposEquipeVendas,
        loading: listarTiposEquipeVendasLoading,
    } = useAsyncEffect(() => ListarEquipesDeVendasController(), [PageFilter]);

    function updateListaTipoCanalAtendimento() {
        listarEquipeVendas();
    }
    //Tabela
    const columns: Array<ColumnDescription<IListarEquipesVendas>> = [
        {
            dataField: "DS_EQUIPE_VENDAS",
            text: "Nome",
            formatter: rowTipoDocumentoEtapa,
            sort: true,
        },
        {
            dataField: "button",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="Button-Tools">
                    <button
                        className="btn btn-outline-primary font-weight-bold mr-2"
                        type="submit"
                        onClick={() => {
                            SetShow(true);
                            SetModal({
                                Component: () =>
                                    AlteracaoEquipeTabs({
                                        ID_EQUIPE_VENDAS: row.ID_EQUIPE_VENDAS,
                                        listarEquipeVendas: listarEquipeVendas,
                                        SetShow: SetShow,
                                    }),
                                customHeader: (
                                    <React.Fragment>
                                        <div className="d-flex align-items-center justify-content-center p-2">
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                size="lg"
                                            />
                                            <span className="font-weight-bolder">
                                                ALTERAÇÃO DE EQUIPE
                                            </span>
                                        </div>
                                        <div className="card-toolbar">
                                            <ul
                                                className="nav nav-tabs nav-bold nav-tabs-line"
                                                role="tablist"
                                                id="#VendasTabs"
                                            >
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link active"
                                                        href="#VendasEquipe"
                                                        data-toggle="tab"
                                                        data-target="#VendasEquipe"
                                                        role="tab"
                                                    >
                                                        <span className="nav-icon">
                                                            <FontAwesomeIcon
                                                                icon={faUsers}
                                                            />
                                                        </span>
                                                        <span className="nav-text">
                                                            Equipe
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link"
                                                        href="#VendasUsuarios"
                                                        data-toggle="tab"
                                                        data-target="#VendasUsuarios"
                                                    >
                                                        <span className="nav-icon">
                                                            <FontAwesomeIcon
                                                                icon={faUser}
                                                            />
                                                        </span>
                                                        <span className="nav-text">
                                                            Usuários
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link"
                                                        href="#VendasProdutos"
                                                        data-toggle="tab"
                                                        data-target="#VendasProdutos"
                                                    >
                                                        <span className="nav-icon">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faProductHunt
                                                                }
                                                            />
                                                        </span>
                                                        <span className="nav-text">
                                                            Produtos
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </React.Fragment>
                                ),
                                size: "xl",
                                noFooter: true,
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este tipo de Documento por Etapa?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletaEquipeVendasController(
                                        row.ID_EQUIPE_VENDAS
                                    ).then(() => {
                                        updateListaTipoCanalAtendimento();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon size="lg" icon={faTrash} /> Excluir
                    </button>
                </div>
            ),
        },
    ];

    function rowTipoDocumentoEtapa(cell: string, row: IListarEquipesVendas) {
        return (
            <div className="rowCapysTCA d-flex justify-content-center align-items-center mr-5">
                <div>
                    <label className="mb-1">{row.DS_EQUIPE_VENDAS}</label>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h2 className="mb-0">Equipe de Vendas</h2>
                    <button
                        className="btn btn-sm btn-shadow btn-success d-flex align-items-center flex-nowrap w-10 mb-4"
                        type="button"
                        onClick={() => {
                            SetShow(true);
                            SetModal({
                                headerComponent: "CADASTRO DE EQUIPE DE VENDAS",
                                Component: () => (
                                    <CriarEquipeDeVendas
                                        updateList={listarEquipeVendas}
                                        setShow={SetShow}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <span className="d-flex align-items-center justify-content-center g-2">
                            Criar Equipe de Venda{" "}
                            <FontAwesomeIcon size="sm" icon={faSave} />
                        </span>
                    </button>
                </div>
                <div className="card-body">
                    <div className="col-12 mt-5">
                        <OrSpinner
                            loading={listarTiposEquipeVendasLoading}
                            spinner="capys"
                        >
                            <Table
                                keyField="ID_TIPO_DOCUMENTO_ETAPA_TIPO_CASO"
                                columns={columns}
                                data={listarTiposEquipeVendas ?? []}
                                sizePerPage={10}
                                loading={listarTiposEquipeVendasLoading}
                                noDataIndication={
                                    <div className="text-center text-muted">
                                        Nenhuma equipe de vendas
                                    </div>
                                }
                                onTableChange={(type, newState) => {
                                    setPage(newState.page);
                                }}
                                wrapperClasses="wrapperTable mw-100 x-scroll"
                                classes="tableClasses"
                                bordered={false}
                                center
                                defaultStyle={{
                                    align: "center",
                                    classes: "p-2",
                                }}
                            />
                            <ExportExcel
                                baixarExcelController={async () =>
                                    ExportEquipeVendas()
                                }
                                nomeArquivo={"Relatorio_Envio_Equipe_vendas"}
                            />
                        </OrSpinner>
                    </div>
                </div>

                <ModalComponent
                    show={show}
                    setShow={SetShow}
                    ModalComponent={Modal}
                />
            </div>
        </>
    );
}

interface IAlteracaoEquipeTabs {
    SetShow: React.Dispatch<React.SetStateAction<boolean>>;
    ID_EQUIPE_VENDAS: number;
    listarEquipeVendas: (...args: any[]) => Promise<IListarEquipesVendas[]>;
}

function AlteracaoEquipeTabs(props: IAlteracaoEquipeTabs) {
    const {
        execute: ListarUsuarioEquipeVendaDesvinculado,
        value: lstUsuarioEquipeVendaDesvinculado,
        loading: lstUsuarioEquipeVendaDesvinculadoLoading,
    } = useAsyncEffect(
        () =>
            ListarUsuarioEquipeVendaDesvinculadoController(
                props.ID_EQUIPE_VENDAS
            ),
        [props.ID_EQUIPE_VENDAS]
    );

    const {
        execute: ListarUsuarioEquipeVendas,
        value: lstUsuarioEquipeVenda,
        loading: lstUsuarioEquipeVendasLoading,
    } = useAsyncEffect(
        () => ListarUsuarioEquipeVendasController(props.ID_EQUIPE_VENDAS),
        [props.ID_EQUIPE_VENDAS]
    );

    const lstSelecionados = useRef<Array<IUsuarioPorEquipeVendas>>([]);

    function handleDesvincularTodosAtributo() {
        DeleteEquipeVendas({
            ID_USUARIO: lstSelecionados.current.map(
                (selecionados) => selecionados.ID_USUARIO
            ),
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            ListarUsuarioEquipeVendas();
            ListarUsuarioEquipeVendaDesvinculado();
        });
    }

    function handleDesvincularAtributoUnico(row: IUsuarioPorEquipeVendas) {
        DeleteEquipeVendas({
            ID_USUARIO: [row.ID_USUARIO],
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            ListarUsuarioEquipeVendas();
            ListarUsuarioEquipeVendaDesvinculado();
        });
    }

    const { execute: DeleteEquipeVendas, loading: DeleteEquipeVendasLoading } =
        useAsyncCallback(DesvincularUsuarioEquipeVendasController);

    // VINCULAR

    const {
        execute: updateInsereEquipeVendasProduto,
        loading: lstVincularUsuarioEquipeVendasLoading,
    } = useAsyncCallback(VincularUsuarioEquipeVendasController, []);

    function handleVincularTodosAtributo() {
        updateInsereEquipeVendasProduto({
            ID_USUARIO: lstSelecionados.current.map(
                (selecionado) => selecionado.ID_USUARIO
            ),
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            ListarUsuarioEquipeVendaDesvinculado();
            ListarUsuarioEquipeVendas();
        });
    }

    function handleVincularAtributoUnico(row: IUsuarioPorEquipeVendas) {
        updateInsereEquipeVendasProduto({
            ID_USUARIO: [row.ID_USUARIO],
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            ListarUsuarioEquipeVendaDesvinculado();
            ListarUsuarioEquipeVendas();
        });
    }

    const {
        execute: updateInsereEquipeVendasProdutoGestaoProdutos,
        loading: insereEtapaCategoriaGestaoProdutosLoading,
    } = useAsyncCallback(VincularProdutoEquipeVendaController, []);

    const lstSelecionadosGestaoProdutos = useRef<
        Array<IGestaoProdutosVinculados>
    >([]);

    function handleVincularTodosAtributoGestaoProdutos() {
        updateInsereEquipeVendasProdutoGestaoProdutos({
            ID_PRODUTO: lstSelecionadosGestaoProdutos.current.map(
                (selecionado) => selecionado.ID_PRODUTO
            ),
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            updateListGestaoProdutos();
            ListarProdutosVinculadosPorVenda();
        });
    }

    function handleVincularAtributoUnicoGestaoProdutos(
        row: IGestaoProdutosVinculados
    ) {
        updateInsereEquipeVendasProdutoGestaoProdutos({
            ID_PRODUTO: [row.ID_PRODUTO],
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            updateListGestaoProdutos();
            ListarProdutosVinculadosPorVenda();
        });
    }

    const {
        value: DesvincularEquipeProdutoGestaoProdutos,
        loading: DesvincularEquipeProdutoGestaoProdutosLoading,
        execute: updateListGestaoProdutos,
    } = useAsyncEffect(
        () =>
            ListarProdutosDesvinculadosPorVendaController(
                props.ID_EQUIPE_VENDAS
            ),
        []
    );

    const {
        execute: ListarProdutosVinculadosPorVenda,
        value: lstProdutosVinculadosPorVenda,
        loading: lstProdutosVinculadosPorVendaLoading,
    } = useAsyncEffect(
        () =>
            ListarProdutosVinculadosPorVendaController(props.ID_EQUIPE_VENDAS),
        [props.ID_EQUIPE_VENDAS]
    );
    const lstSelecionadosDeleteGestaoProdutos = useRef<
        Array<IGestaoProdutosVinculados>
    >([]);
    function handleDesvincularTodosAtributoDeleteGestaoProdutos() {
        DeleteEquipeVendasGestaoProdutos({
            ID_PRODUTO: lstSelecionadosDeleteGestaoProdutos.current.map(
                (selecionado) => selecionado.ID_PRODUTO
            ),
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            ListarProdutosVinculadosPorVenda();
            updateListGestaoProdutos();
        });
    }

    function handleDesvincularAtributoUnicoDeleteGestaoProdutos(
        row: IGestaoProdutosVinculados
    ) {
        DeleteEquipeVendasGestaoProdutos({
            ID_PRODUTO: [row.ID_PRODUTO],
            ID_EQUIPE_VENDAS: props.ID_EQUIPE_VENDAS,
        }).then(() => {
            ListarProdutosVinculadosPorVenda();
            updateListGestaoProdutos();
        });
    }

    const {
        execute: DeleteEquipeVendasGestaoProdutos,
        loading: DeleteEquipeVendasLoadingGestaoProdutos,
    } = useAsyncCallback(DeletarProdutoEquipeVendaController);

    return (
        <div className="tab-content" id="VendasTabs">
            <div
                className="tab-pane fade active show"
                id="VendasEquipe"
                role="tabpanel"
                aria-labelledby="VendasEquipe"
            >
                <CriarEquipeDeVendas
                    idEquipeVendas={props.ID_EQUIPE_VENDAS}
                    setShow={props.SetShow}
                    updateList={props.listarEquipeVendas}
                />
            </div>
            <div
                className="tab-pane fade"
                id="VendasUsuarios"
                role="tabpanel"
                aria-labelledby="VendasUsuarios"
            >
                <div className="Row2 flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
                    <div className="col-12 col-lg-6">
                        <ProdutosVinculadosUsuarioPorEquipe
                            idEquipeVendas={props.ID_EQUIPE_VENDAS}
                            ListarUsuarioEquipeVendaDesvinculado={
                                ListarUsuarioEquipeVendaDesvinculado
                            }
                            lstUsuarioEquipeVendaDesvinculadoLoading={
                                lstUsuarioEquipeVendaDesvinculadoLoading
                            }
                            DeleteEquipeVendasLoading={
                                DeleteEquipeVendasLoading
                            }
                            handleDesvincularAtributoUnico={
                                handleDesvincularAtributoUnico
                            }
                            handleDesvincularTodosAtributo={
                                handleDesvincularTodosAtributo
                            }
                            lstSelecionados={lstSelecionados}
                            lstUsuarioEquipeVenda={lstUsuarioEquipeVenda}
                            lstUsuarioEquipeVendaLoading={
                                lstUsuarioEquipeVendasLoading
                            }
                        />
                    </div>
                    <div className="col-md-6">
                        <ProdutosDesvinculadosUsuarioPorEquipe
                            idEquipeVendas={props.ID_EQUIPE_VENDAS}
                            idProduto={props.ID_EQUIPE_VENDAS}
                            ListarUsuarioEquipeVendas={
                                ListarUsuarioEquipeVendas
                            }
                            lstUsuarioEquipeVendasLoading={
                                lstUsuarioEquipeVendasLoading
                            }
                            handleVincularAtributoUnico={
                                handleVincularAtributoUnico
                            }
                            handleVincularTodosAtributo={
                                handleVincularTodosAtributo
                            }
                            lstSelecionados={lstSelecionados}
                            lstUsuarioEquipeVendaDesvinculado={
                                lstUsuarioEquipeVendaDesvinculado
                            }
                            lstUsuarioEquipeVendaDesvinculadoLoading={
                                lstUsuarioEquipeVendaDesvinculadoLoading
                            }
                            lstVincularUsuarioEquipeVendasLoading={
                                lstVincularUsuarioEquipeVendasLoading
                            }
                        />
                    </div>
                </div>
            </div>
            <div
                className="tab-pane fade"
                id="VendasProdutos"
                role="tabpanel"
                aria-labelledby="VendasProdutos"
            >
                <div className="Row2 flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
                    <div className="col-12 col-lg-6">
                        <ProdutosVinculados
                            idEquipeVendas={props.ID_EQUIPE_VENDAS}
                            DeleteEquipeVendasLoadingGestaoProdutos={
                                DeleteEquipeVendasLoadingGestaoProdutos
                            }
                            ListarProdutosVinculadosPorVenda={
                                ListarProdutosVinculadosPorVenda
                            }
                            handleDesvincularAtributoUnicoDeleteGestaoProdutos={
                                handleDesvincularAtributoUnicoDeleteGestaoProdutos
                            }
                            handleDesvincularTodosAtributoDeleteGestaoProdutos={
                                handleDesvincularTodosAtributoDeleteGestaoProdutos
                            }
                            lstProdutosVinculadosPorVenda={
                                lstProdutosVinculadosPorVenda
                            }
                            lstProdutosVinculadosPorVendaLoading={
                                lstProdutosVinculadosPorVendaLoading
                            }
                            lstSelecionadosDeleteGestaoProdutos={
                                lstSelecionadosDeleteGestaoProdutos
                            }
                        />
                    </div>
                    <div className="col-md-6">
                        <ProdutosDesvinculados
                            idEquipeVendas={props.ID_EQUIPE_VENDAS}
                            idProduto={props.ID_EQUIPE_VENDAS}
                            DesvincularEquipeProdutoGestaoProdutos={
                                DesvincularEquipeProdutoGestaoProdutos
                            }
                            DesvincularEquipeProdutoGestaoProdutosLoading={
                                DesvincularEquipeProdutoGestaoProdutosLoading
                            }
                            handleVincularAtributoUnicoGestaoProdutos={
                                handleVincularAtributoUnicoGestaoProdutos
                            }
                            handleVincularTodosAtributoGestaoProdutos={
                                handleVincularTodosAtributoGestaoProdutos
                            }
                            insereEtapaCategoriaGestaoProdutosLoading={
                                insereEtapaCategoriaGestaoProdutosLoading
                            }
                            lstSelecionadosGestaoProdutos={
                                lstSelecionadosGestaoProdutos
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
